import { graphql } from 'gql.tada';
import { useMutation } from '@apollo/client';
import { HouseholdChangeRequestFragment } from './HouseholdChangeRequestFragment';

const SubmitHouseholdChangeRequestMutation = graphql.persisted(
  "SubmitHouseholdChangeRequest",
  graphql(`
    mutation SubmitHouseholdChangeRequest(
      $familyId: ID!
      $address: AddressInput
      $emergencyContacts: [EmergencyContactInput!]
      $authorizedPickup: [AuthorizedPickupInput!]
      $churchAffiliation: ChurchAffiliationInput
      $guardians: [GuardianContactInput!]
    ) {
      submitHouseholdChangeRequest(input: {
        familyId: $familyId
        address: $address
        emergencyContacts: $emergencyContacts
        authorizedPickup: $authorizedPickup
        churchAffiliation: $churchAffiliation
        guardians: $guardians
      }) {
        changeRequest { ...HouseholdChangeRequestFragment }
        userErrors { message path }
      }
    }
  `, [HouseholdChangeRequestFragment])
);

export { SubmitHouseholdChangeRequestMutation };

export function useSubmitHouseholdChangeRequest() {
  return useMutation(SubmitHouseholdChangeRequestMutation);
}
